import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { TAssetFileExt, ThemeAssetComponent } from '@partners/themes';
import { FlexUtilsImportPack } from '../../directives';

@Component({
  selector: 'card-illustration',
  standalone: true,
  imports: [ThemeAssetComponent, FlexUtilsImportPack],
  template: `
    <theme-asset [asset]="cardImageId" [extension]="imageExtension" data-alt="תמונת הכרטיס החדש שלך"></theme-asset>
    <div class="card-details" layout="column" layout-align="end end">
      <span class="owner-name">{{ ownerName }}</span>
      <span class="last-digits">{{ last4Digits }}</span>
    </div>
  `,
  styles: [``],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'card-illustration'
  }
})
export class CardIllustrationComponent {
  @Input()
  ownerName: string;

  @Input()
  last4Digits: string;

  @Input()
  imageExtension: TAssetFileExt = 'png';

  @Input()
  set cardImageId(value: string | number) {
    this._imageId = value.toString();
  }

  get cardImageId(): string {
    return `card-illustration-${this._imageId}`;
  }

  private _imageId: string = null;
}
